import { startOfWeek as startOfWeekBase } from 'date-fns'

export function startOfWeek(locale: Locale) {
  return (date: Date) => startOfWeekBase(date, { locale, weekStartsOn: 1 })
}
